<ng-container *transloco="let t; prefix: 'subscriptions.billing.unsubcribeComplete'">
  <mat-card class="mx-auto my-20 w-full max-w-2xl p-10">
    <div class="pb-10">
      <h1 class="text-heading-2">{{ t('heading') }}</h1>
      <ul class="mt-4 flex flex-col gap-6">
        <li class="flex flex-row items-start text-steel-70 md:items-center">
          <rma-icon class="mr-4" [rounded]="true" size="normal" glyph="event" theme="primary" />
          <p [innerHTML]="t('cycleEnds', { subscriptionEndsOn: currentSubscriptionEnds$ | async | date })"></p>
        </li>
        <li class="mr-4 flex flex-row items-start text-steel-70 md:items-center">
          <rma-icon class="mr-4" [rounded]="true" size="normal" glyph="exit_to_app" theme="primary" />
          <p [innerHTML]="t('downgradeTo')"></p>
        </li>
        <li class="mr-4 flex flex-row items-start text-steel-70 md:items-center">
          <rma-icon class="mr-4" [rounded]="true" size="normal" glyph="thumb_up" theme="primary" />
          <p [innerHTML]="t('accessToReviews')"></p>
        </li>
      </ul>
    </div>
    <a type="button" class="mx-auto mb-10" [routerLink]="'/manage-account/billing'" mat-flat-button color="primary">{{
      t('button.text')
    }}</a>

    @if ((displayThankYou$ | async) === null) {
      <div class="rounded-md bg-steel-10 p-6 pt-10">
        <h2 class="mb-6" [innerHTML]="t('reasons.heading')"></h2>
        <form [formGroup]="unSubscriptionCompleteForm.form" (ngSubmit)="unSubscriptionCompleteForm.validateAndSubmit()">
          <mat-form-field class="w-full">
            <mat-select [placeholder]="t('dropdownPlaceholder')" formControlName="likedReason">
              @for (reason of reasons$ | async; track reason) {
                <mat-option [value]="reason">
                  {{ t('reasons.' + (reason | lowercase)) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (isOtherSelected$ | async) {
            <mat-form-field class="w-full">
              <mat-label>{{ t('feedback') }}</mat-label>
              <textarea matInput formControlName="likedReasonText" placeholder=""></textarea>
            </mat-form-field>
          }
          <div class="text-right">
            <button
              type="submit"
              class="block w-full md:flex md:w-auto"
              [rmaLoadingIndicator]="isSubmitting$ | async"
              mat-flat-button
              color="primary"
            >
              <span>{{ t('submit') }}</span>
            </button>
          </div>
        </form>
      </div>
    } @else {
      <rma-unsubscribe-thankyou class="rounded-md bg-steel-10 p-6" />
    }
  </mat-card>
</ng-container>
